document.addEventListener('findstrLoaded', () => {
  const { hooks } = window.findstr || {};

  if (!hooks) {
    return;
  }

  hooks.addAction(
    'searchResults',
    'post-listing-results-count',
    (results, group) => {
      if (group !== 'post-listing') {
        return;
      }

      const countEl = document.querySelector(
        `.findstr-results-count[data-group="${group}"]`
      );
      const termEl = document.querySelector(
        `.findstr-search-term[data-group="${group}"]`
      );

      if (countEl) {
        countEl.textContent = results.totalHits;
      }

      if (termEl) {
        termEl.textContent = results.query || '';
      }
    }
  );

  hooks.addFilter(
    'searchResults',
    'post-listing-card-excerpt',
    (results, group) => {
      if (
        group !== 'post-listing' ||
        !results ||
        !Array.isArray(results.hits)
      ) {
        return results;
      }

      const hasQuery = String(results.query || '').trim() !== '';

      results.hits.forEach((hit) => {
        hit.use_card_excerpt = !hasQuery && Boolean(hit.card_excerpt);
      });

      return results;
    }
  );
});
